import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button, ButtonGroup } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilMisalLelangKelompok = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const { id, idMisalLelangKelompok } = useParams();
  const [no, setNo] = useState("");
  const [misalLelang, setMisalLelang] = useState("");

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  let isEditableManager = user.tipeUser !== "ADMIN";
  let isEditableAdmin = true;
  let isEditable = isEditableManager || isEditableAdmin;

  useEffect(() => {
    getMisalLelangKelompokById();
  }, []);

  const getMisalLelangKelompokById = async () => {
    if (id) {
      const response = await postRequest(
        `/misalLelangKelompoks/${idMisalLelangKelompok}`,
        {},
        navigate,
        dispatch,
      );
      setNo(response.data.no);
      setMisalLelang(response.data.misalLelang.toLocaleString("de-DE"));
    }
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Arisan</h3>
      <h5 style={{ fontWeight: 400 }}>Detail Misal Lelang Kelompok</h5>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate(`/daftarKelompok/kelompok/${id}`)}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={deleteButtonContainer}>
        {isEditable && (
          <ButtonGroup variant="contained">
            <Button
              color="primary"
              startIcon={<EditIcon />}
              sx={{ textTransform: "none" }}
              onClick={() => {
                navigate(
                  `/daftarKelompok/kelompok/${id}/misalLelangKelompok/${idMisalLelangKelompok}/edit`,
                );
              }}
            >
              Ubah
            </Button>
          </ButtonGroup>
        )}
      </Box>
      <hr />
      <Card>
        <Card.Header>Detail Misal Lelang Kelompok</Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={no} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Misal Lelang :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={misalLelang} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TampilMisalLelangKelompok;

const deleteButtonContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
